<template>
<md-dialog
  :md-active.sync="active"
  :md-close-on-esc="false"
  :md-click-outside-to-close="false"
  :class="['aml-dialog', {'custom-padding': padding}]"
  :data-notif-id="values.notif_id"
>
    <md-progress-bar md-mode="indeterminate" v-if="isLoading"/>
    <template v-if="!isRefundFormShow">
      <md-dialog-title class="dialog-title">
        <span>{{ i18n.lbl_aml_title_large() }}</span>

        <md-button
          class="md-icon-button md-raised md-dense close-btn"
          @click="$emit('close')"
        >
          <md-icon>close</md-icon>
        </md-button>
      </md-dialog-title>
      <detail v-if="values.status" :prop="i18n.lbl_status()" :bold="isShowStatus" :capitalize="true" :value="values.status"  :valueTextColor="isShowStatus ? 'red' : '$col-text'"/>
      <detail v-if="values.reason" :prop="i18n.lbl_reason()" :value="capitalizeReason" :valueTextColor="isShowStatus ? 'red' : '$col-text'"/>
      <detail v-if="values.timeStamp" :prop="i18n.lbl_time_optional()"  :value="values.timeStamp"/>
      <!-- <detail v-if="values.order_uuid" :prop="i18n.lbl_order_uid()"  :value="values.order_uuid" :copiable="true"/> -->
      <detail v-if="values.client_wallet" :prop="i18n.lbl_client_wallet()"  :value="values.client_wallet" :copiable="true"/>
      <detail v-if="values.hash" :prop="i18n.lbl_client_hash()"  :value="values.hash" :copiable="true"/>
      <detail v-if="values.wallet" :prop="walletLabel" :value="values.wallet" :copiable="true"/>
      <detail v-if="values.asset" :prop="i18n.lbl_asset()"  :value="formatToken"/>
      <detail v-if="values.amount" :prop="i18n.lbl_amount()"  :value="amount"/>
      <detail v-if="values.order_no" :prop="i18n.lbl_order_id()"  :value="values.order_no" :copiable="true"/>
      <detail v-if="values.order_amount" :prop="i18n.lbl_order_amount()"  :value="orderAmount"/>
      <detail v-if="values.order_network" :prop="i18n.lbl_order_network()" :value="values.order_network"/>
      <detail v-if="values.error" :prop="i18n.lbl_reason()"  :value="values.error"/>
      <CheckSignList v-if="isWithdrawalTransaction && values.first_level_sign" :signs="values.first_level_sign"/>
      <Aml v-if="amlValues && !isShowStatus" :score="riskScore" :values="amlValues" :higthRisk="higthRisks"/>
      <md-dialog-actions v-if="values.type === 2">
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" v-if="isShowRefund" @click="getRefundStatus">{{ i18n.lbl_refund() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="deposit">{{ i18n.lbl_deposit_white() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="depositDirty">{{ i18n.lbl_credit_dirty() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="postpone">{{ i18n.lbl_put_aside() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default md-yellow" :disabled="isLoading" @click="checkManual">{{ i18n.lbl_check_crystal() }}</md-button>
      </md-dialog-actions>
      <md-dialog-actions v-if="values.type === 3">
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="withdrawal">{{ i18n.withdraw_withdraw() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="cencelWithdrawal">{{ i18n.lbl_withdrawal_cancel() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="postpone">{{ i18n.lbl_put_aside() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default md-yellow" :disabled="isLoading" @click="checkManual">{{ i18n.lbl_check_crystal() }}</md-button>
      </md-dialog-actions>
      <md-dialog-actions v-if="values.type === -1">
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" v-if="isShowRefund" @click="getRefundStatus">{{ i18n.lbl_refund() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="deposit">{{ i18n.lbl_deposit_white() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="depositDirty">{{ i18n.lbl_credit_dirty() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="checkAgaingDeposit">{{ i18n.lbl_check_again() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="postpone">{{ i18n.lbl_put_aside() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default md-yellow" :disabled="isLoading" @click="checkManual">{{ i18n.lbl_check_crystal() }}</md-button>
      </md-dialog-actions>
      <md-dialog-actions v-if="values.type === -2">
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="withdrawal">{{ i18n.withdraw_withdraw() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="cencelWithdrawal">{{ i18n.lbl_withdrawal_cancel() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="checkAgaingWithdrawal">{{ i18n.lbl_check_again() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="postpone">{{ i18n.lbl_put_aside() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default md-yellow" :disabled="isLoading" @click="checkManual">{{ i18n.lbl_check_crystal() }}</md-button>
      </md-dialog-actions>

      <p class="text-center error" v-if="error">{{ i18n.lbl_something_wrong() }}</p>
    </template>
    <template v-else>
      <RefundModal :token="formatToken" :isLoading="isLoading" :status="refundStatus" :values="values" @deleteNotif="deleteNotif" @refreshStatus="getRefundStatus" @close="toggleRefund" @setIsLoading="setIsLoading" @toggleError="toggleError"/>
    </template>
</md-dialog>
</template>

<script>
import Aml from '../app/history/index/components/Aml.vue'
import RefundModal from './RefundModal.vue'
import Detail from '@vue/app/common/Detail.Row'
import CheckSignList from '@vue/app/widrawalRequest/CheckSignList.vue'
import { vuexTypes } from '@vuex/types'
import { i18n } from '@js/i18n'
import { getTokenNetwork, formatTokenDisplay } from '@utils/consts'
import CurrencyRound from '@com/mixins/currency.round.mixin'
import { mapActions, mapGetters } from 'vuex'
import apiHelper from '@utils/cunstomInterseptor'
import { confirmAction } from '@js/modals/confirmation_message'

// Backend network enum for pending deposit/withdrawal moderation calls
const NETWORK_ENUM = { ERC20: 0, BEP20: 1, TRC20: 2 }

export default {
  name: 'AmlDialog',
  components: { Aml, CheckSignList, Detail, RefundModal },
  mixins: [CurrencyRound],
  data () {
    return {
      i18n,
      isLoading: false,
      error: false,
      isRefundFormShow: false,
      refundStatus: null
    }
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    values: {
      type: Object,
      required: true
    },
    account: {
      type: String,
      required: true
    },
    padding: {
      type: Boolean,
      default: true
    }
  },
  emits: ['close'],
  methods: {
    ...mapActions({
      deleteNotificationById: 'deleteNotificationById'
    }),
    toggleRefund () {
      this.isRefundFormShow = !this.isRefundFormShow
    },
    toggleError (val) {
      this.error = val
    },
    async getRefundStatus () {
      try {
        this.error = false
        this.isLoading = true
        const { data } = await apiHelper.get(`/refund/status?wallet=${this.values.wallet}`)
        this.refundStatus = data
        this.refundStatus.refund_amount = this.roundCurrency2(Number(this.refundStatus.refund_amount) / 1000000, this.values.asset)
        this.refundStatus.refund_commission = this.roundCurrency2(Number(this.refundStatus.refund_commission) / 1000000, this.values.asset)
        this.refundStatus.source_balance = this.roundCurrency2(Number(this.refundStatus.source_balance) / 1000000, this.values.asset)
        this.isRefundFormShow = true
      } catch (err) {
        this.error = true
        console.log(err)
      } finally {
        this.isLoading = false
      }
    },
    setIsLoading (val) {
      this.isLoading = val
    },
    async cencelWithdrawal () {
      const confirmModalResult = await confirmAction({
        title: i18n.mod_withdrawal_confirm_title(),
        message: i18n.mod_withdrawal_confirm_message(),
        confirmText: i18n.lbl_confirm(),
        cancelText: i18n.lbl_cancel(),
        closeOnEsc: false,
        closeOnBackdrop: false
      })
      if (!confirmModalResult) return

      try {
        this.isLoading = true
        this.error = false
        let asset = NETWORK_ENUM[getTokenNetwork(this.values.asset)] !== undefined ? NETWORK_ENUM[getTokenNetwork(this.values.asset)] : 1
        const isType = (this.values.type === 3 || this.values.type === -2) || false
        const sendData = {network: asset}
        if (isType) {
          sendData.direction = this.values.tx_direction || this.values.TxDirection
          sendData.pending_withdrawal_id = this.values.id
          sendData.approval_level = 1
        }
        await apiHelper.put(`/cancel_pending_withdrawal`, {
          ...sendData
        })
        await this.deleteNotificationById(this.values)
        this.isLoading = false
        this.$emit('close')
      } catch (e) {
        this.error = true
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async deleteNotif () {
      await this.deleteNotificationById(this.values)
      this.$emit('close')
    },
    async deposit () {
      try {
        this.isLoading = true
        this.error = false
        let asset = NETWORK_ENUM[getTokenNetwork(this.values.asset)] !== undefined ? NETWORK_ENUM[getTokenNetwork(this.values.asset)] : 1
        const sendData = {network: asset}
        sendData.direction = this.values.tx_direction || this.values.TxDirection
        sendData.pending_deposit_id = this.values.id
        await apiHelper.put(`/confirm_pending_deposit/clean`, {
          ...sendData
        })
        await this.deleteNotificationById(this.values)
        this.isLoading = false
        this.$emit('close')
      } catch (e) {
        this.error = true
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async withdrawal () {
      try {
        this.isLoading = true
        this.error = false
        let asset = NETWORK_ENUM[getTokenNetwork(this.values.asset)] !== undefined ? NETWORK_ENUM[getTokenNetwork(this.values.asset)] : 1
        const sendData = {network: asset}
        sendData.direction = this.values.tx_direction || this.values.TxDirection
        sendData.pending_withdrawal_id = this.values.id
        sendData.approval_level = 1
        await apiHelper.put(`/confirm_pending_withdrawal`, {
          ...sendData
        })
        await this.deleteNotificationById(this.values)
        this.isLoading = false
        this.$emit('close')
      } catch (e) {
        this.error = true
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async depositDirty () {
      try {
        this.isLoading = true
        this.error = false
        let asset = NETWORK_ENUM[getTokenNetwork(this.values.asset)] !== undefined ? NETWORK_ENUM[getTokenNetwork(this.values.asset)] : 1
        const sendData = {network: asset}
        sendData.direction = this.values.tx_direction || this.values.TxDirection
        sendData.pending_deposit_id = this.values.id
        await apiHelper.put(`/confirm_pending_deposit/dirty`, {
          ...sendData
        })
        await this.deleteNotificationById(this.values)
        this.isLoading = false
        this.$emit('close')
      } catch (e) {
        this.error = true
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async checkAgaingDeposit () {
      try {
        this.isLoading = true
        this.error = false
        let asset = NETWORK_ENUM[getTokenNetwork(this.values.asset)] !== undefined ? NETWORK_ENUM[getTokenNetwork(this.values.asset)] : 1
        await apiHelper.post(`/aml_check_deposit_again`, {
          network: asset,
          pending_deposit_id: this.values.id
        })
        await this.deleteNotificationById(this.values)
        this.isLoading = false
        this.$emit('close')
      } catch (e) {
        this.error = true
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async checkAgaingWithdrawal () {
      try {
        this.isLoading = true
        this.error = false
        let asset = NETWORK_ENUM[getTokenNetwork(this.values.asset)] !== undefined ? NETWORK_ENUM[getTokenNetwork(this.values.asset)] : 1
        await apiHelper.post(`/aml_check_withdrawal_again`, {
          network: asset,
          pending_withdrawal_id: this.values.id
        })
        await this.deleteNotificationById(this.values)
        this.isLoading = false
        this.$emit('close')
      } catch (e) {
        this.error = true
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async postpone () {
      try {
        this.isLoading = true
        this.error = false
        this.$emit('close')
      } catch (e) {
        this.error = true
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async checkManual () {
      try {
        this.isLoading = true
        let asset = NETWORK_ENUM[getTokenNetwork(this.values.asset)] !== undefined ? NETWORK_ENUM[getTokenNetwork(this.values.asset)] : 1
        await apiHelper.put(`/manual_aml_check_deposit`, {
          network: asset
        })
        if (this.values.type === 2) {
          window.open(`https://expert.crystalintelligence.com/trx/tx/${this.values.hash}?tab=internal`)
        } else if (this.values.type === 3) {
          window.open(`https://expert.crystalintelligence.com/trx/address/${this.values.wallet}?tab=connections`)
        } else if (this.values.type === -1) {
          window.open(`https://expert.crystalintelligence.com/trx/tx/${this.values.hash}?tab=internal`)
        } else if (this.values.type === -2) {
          window.open(`https://expert.crystalintelligence.com/trx/address/${this.values.wallet}?tab=connections`)
        }
        this.isLoading = false
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    }
  },
  computed: {
    ...mapGetters([
      vuexTypes.userEmail
    ]),
    capitalizeReason () {
      if (this.values.reason) {
        let str = this.values.reason.trim()
        return str.charAt(0).toUpperCase() + str.slice(1)
      }
      return ''
    },
    isShowRefund () {
      return Boolean(this.values.wallet)
    },
    amount () {
      if (this.values.amount) {
        // AML notifications provide all network amounts in normalized micro units.
        const num = Number(this.values.amount) / 1000000
        return this.roundCurrency3(num, this.values.asset)
      }
    },
    orderAmount () {
      if (this.values.order_amount) {
        return `${this.roundCurrency3(this.values.order_amount)} ${this.values.order_currency}`
      }
      return false
    },
    isShowStatus () {
      if (this.values.status.toLowerCase() === 'failed') {
        return true
      }
      return false
    },
    isWithdrawalTransaction () {
      return this.values.type === 3 || this.values.type === -2
    },
    formatToken () {
      let token = formatTokenDisplay(this.values.asset)
      return token
    },
    amlValues () {
      // eslint-disable-next-line
      if (this.values.fields) {
        let { riskscore, ...others } = this.values.fields
        return others
      }
      return null
    },
    riskScore () {
      if (this.values.fields && this.values.fields.riskscore) {
        return (Number(this.values.fields.riskscore) * 100).toFixed(1)
      }
      return null
    },
    higthRisks () {
      if (this.values.high_risk_fields) {
        return this.values.high_risk_fields
      }
      return []
    },
    walletLabel () {
      switch (this.values.type) {
        case 3:
        case -2:
          return this.i18n.lbl_wallet()
        case 2:
        case -1:
          return this.i18n.lbl_one_time_wallet()
        default:
          return this.i18n.lbl_wallet()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.w-100 {
  width: 100%;
}
.custom-padding {
  padding-right: 56px !important;
}
.error {
  text-align: center;
  color: red;
}
.md-title {
    padding-left: 0;
}

.aml-dialog {
  .dialog-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 0px;
    padding-right: 0px;
    width: 100%;
    position: relative;

    .close-btn {
      margin: 0;
      position: absolute;
      right: -44px;
      top: -16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/navigation/AmlDialog.vue